import React from 'react'
import FormLabel from './FormLabel'
import {Field} from 'redux-form'

const FormInput = (props) => (
    <div>
      {(props.name) ? <FormLabel  {...props} /> : ''}
      <Field type="text" id={props.id} name={props.id}
             className="form__input"
             placeholder={props.placeholder}
             component="input"
      />
    </div>
)

export default FormInput;


// WEBPACK FOOTER //
// ./src/components/FormInput.jsx